import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../../core/auth.service';
import * as _ from 'lodash';
import { AppService } from '../../../../app.service';
import { BaseComponent } from '../../../../shared/base.component';
import { BaseService } from '../../../../shared/base.service';
import { TokensService } from '../tokens.service';

@Component({
    templateUrl: 'token-modal.component.html',
    styleUrls: ['token-modal.component.scss'],
    providers: [
        TokensService
    ]
})

export class TokenModalComponent extends BaseComponent implements OnInit, AfterViewInit {

    url = 'insurance-dashboard/tokens';

    constructor(protected fb: FormBuilder,
                public authService: AuthService,
                public route: ActivatedRoute,
                public router: Router,
                public appService: AppService,
                public tokensService: TokensService,
                public baseService : BaseService) {

        super(authService, router, baseService, appService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.appService.isLoading = false;

        this.route.params.subscribe(params => {
            this.params = params;
        });
    }

    ngAfterViewInit() {
        this.modal.config.backdrop = false;
        this.modal.config.ignoreBackdropClick = true;
        this.modal.config.keyboard = false;

        this.form = this.fb.group({
            description: ['', [<any>Validators.required, <any>Validators.minLength(3)]],
        });
        this.showModal();
    }

    submit(model: any, isValid: boolean) {
        this.formSubmitted = true;

        if (!isValid) {
            return;
        }

        this.resetErrors();
        this.appService.isLoading = true;

        this.tokensService.saveToken(model).subscribe(
            () => {
                this.hideModal();
            });
    }

    hideModal() {
        // Use this to force parent router reload after close modal
        this.router.navigate(['./'],
            {
                relativeTo: this.route.parent
            });
    }
}
